import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import ReactHtmlParser from 'react-html-parser';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './Accessibility.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Accessibility extends Component {
  	render() {
		return (
			<div className="showtix-section container">
				<div className="row">
					<div className="col-12">
						<h1 id="sr-title">{strings.title}</h1>
						<p>{strings.date}</p>
					</div>
				</div>

				<div className="row">
					<div className="col-12">
						{ReactHtmlParser(strings.content)}

						<h2>Table 1: Success Criteria, Level A</h2>
						<table className="showtix-table showtix-table__accessibility">
							<thead>
								<tr>
									<th>Criteria</th>
									<th>Conformance Level</th>
									<th>Remarks and Explanations</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
									1.1.1 Non-text content (Level A)
									</td>
									<td>
									Partially supports
									</td>
									<td>
									Showtix4U presents all non-text content a text alternative that serves the equivalent purpose, with the only exceptions of 3rd-party images like:
									<br />• Share icons on Event Landing page
									</td>
								</tr>
								<tr>
									<td>
									1.2.1 Audio-only and Video-only (Prerecorded) (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U uses Vimeo to display any video or audio performances.<br />
									The Promoters providing the performance must provide captions and/or description, Showtix4U is not responsible for the content.<br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054813011-Arts-Organization-Closed-Captioning-ASL-For-Live-Stream">Closed Captioning for Live Stream</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363092-Arts-Organization-Closed-Captioning-for-Scheduled-Content-SC-">Closed Captioning for Scheduled Content</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363412-Arts-Organization-Closed-Captioning-for-Video-On-Demand-VOD-">Closed Captioning for Video On Demand</a>
									
									</td>
								</tr>
								<tr>
									<td>
									1.2.2 Captions (Prerecorded) (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U uses Vimeo to display any video or audio performances.<br />
									The Promoters providing the performance must provide captions and/or description, Showtix4U is not responsible for the content.<br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054813011-Arts-Organization-Closed-Captioning-ASL-For-Live-Stream">Closed Captioning for Live Stream</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363092-Arts-Organization-Closed-Captioning-for-Scheduled-Content-SC-">Closed Captioning for Scheduled Content</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363412-Arts-Organization-Closed-Captioning-for-Video-On-Demand-VOD-">Closed Captioning for Video On Demand</a>
									</td>
								</tr>
								<tr>
									<td>
									1.2.3 Audio Description or Media Alternative (Prerecorded) (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U uses Vimeo to display any video or audio performances.<br />
									The Promoters providing the performance must provide captions and/or description, Showtix4U is not responsible for the content.<br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054813011-Arts-Organization-Closed-Captioning-ASL-For-Live-Stream">Closed Captioning for Live Stream</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363092-Arts-Organization-Closed-Captioning-for-Scheduled-Content-SC-">Closed Captioning for Scheduled Content</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363412-Arts-Organization-Closed-Captioning-for-Video-On-Demand-VOD-">Closed Captioning for Video On Demand</a>
									
									</td>
								</tr>
								<tr>
									<td>
									1.3.1 Info and Relationships (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U conveys the information, structure, and relationships by accessible methods. <br />
• All headings follow logical order.<br />
• All items are marked up properly.
									</td>
								</tr>
								<tr>
									<td>
									1.3.2 Meaningful Sequence (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U has a logical reading order.
									</td>
								</tr>
								<tr>
									<td>
									1.3.3 Sensory Characteristics  (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not present information that solely relies on the sensory characteristics of components, such as shape, color, size, visual location, orientation, or sound.
									</td>
								</tr>
								<tr>
									<td>
									1.4.1 Use of Color (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not use color as the only visual means of conveying information, indicating an action, prompting a response, or distinguishing a visual element.
									</td>
								</tr>
								<tr>
									<td>
									2.1.1 Keyboard (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									All active elements in the product are in the focus order and are operable through a keyboard interface. 
									</td>
								</tr>
								<tr>
									<td>
									2.1.2 No Keyboard Trap (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not contain keyboard traps.
									</td>
								</tr>
								<tr>
									<td>
									2.1.4 Character Key Shortcuts (Level A 2.1 only)
									</td>
									<td>
									N/A
									</td>
									<td>
									The product does not provide character key shortcuts.
									</td>
								</tr>
								<tr>
									<td>
									2.2.1 Timing Adjustable (Level A)
									</td>
									<td>
									Partially Supports
									</td>
									<td>
									Due to the nature of the product, there is a fixed time limit of 10 minutes to purchase tickets.
However, we do have a message that lets people know that there’s a time limit.
									</td>
								</tr>
								<tr>
									<td>
									2.2.2 Pause, Stop, Hide (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									The product does not include content that plays automatically.
									</td>
								</tr>
								<tr>
									<td>
									2.3.1 Three Flashes or Below Threshold (Level A)
									</td>
									<td>
									N/A
									</td>
									<td>
									The product does not utilize any flashing content.
									</td>
								</tr>
								<tr>
									<td>
									2.4.1 Bypass Blocks (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									The product provides a method to skip past blocks of repeated content or contains such limited amount of data that it is not necessary to provide this mechanism. 
									</td>
								</tr>
								<tr>
									<td>
									2.4.2 Page Titled (Level A)
									</td>
									<td>
									Partially Supports
									</td>
									<td>
									Showtix4U has titles for each of its webpages. However, a rating of Partially Supports has been given for the following reason:<br />
• All pages have the generic title ‘ShowTix4U – Free Online Ticketing – Schools, Community, Regional’ which do not update regardless of what page/tab the user visits.

									</td>
								</tr>
								<tr>
									<td>
									2.4.3 Focus Order (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									The elements of Showtix4U pages can be navigated sequentially, and focusable components receive focus in an order that preserves meaning and operability.
									</td>
								</tr>
								<tr>
									<td>
									2.4.4 Link Purpose (In Context) (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									The purpose of each of the links can be determined from the link text or from the link text together with its programmatically determined link context on Showtix4U pages.
									</td>
								</tr>
								<tr>
									<td>
									2.5.1 Pointer Gestures (Level A 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not use multipoint or path-based gestures for operation.</td>
								</tr>
								<tr>
									<td>
									2.5.2 Pointer Cancellation (Level A 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not execute any functionality on the down-event of the pointer.
									</td>
								</tr>
								<tr>
									<td>
									2.5.3 Label in Name (Level A 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U presents user interface components whose accessible name contains the text presented visually.
									</td>
								</tr>
								<tr>
									<td>
									2.5.4 Motion Actuation (Level A 2.1 only)
									</td>
									<td>
									Does not support
									</td>
									<td>
									Showtix4U does not contain user interface components that require device or user motion.
									</td>
								</tr>
								<tr>
									<td>
									3.1.1 Language of Page (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U identifies the default language of its pages.
									</td>
								</tr>
								<tr>
									<td>
									3.2.1 On Focus (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									None of the user interface components on Showtix4U that receive focus initiate a change of context.
									</td>
								</tr>
								<tr>
									<td>
									3.2.2 On Input (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not initiate a change of context when any component setting is changed.
									</td>
								</tr>
								<tr>
									<td>
									3.3.1 Error Identification (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Where input errors are automatically detected, such as when required fields are not filled out when editing forms, items in error are identified and error messages are displayed.
									</td>
								</tr>
								<tr>
									<td>
									3.3.2 Labels or Instructions (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									Labels or instructions are provided for all of the input fields.
									</td>
								</tr>
								<tr>
									<td>
									4.1.1 Parsing (Level A)
									</td>
									<td>
									Supports
									</td>
									<td>
									The product implements well-formed markup.
									</td>
								</tr>
								<tr>
									<td>
									4.1.2 Name, Role, Value (Level A)
									</td>
									<td>
									Partially supports
									</td>
									<td>
									Showtix4U controls’ name, role, state, and value is exposed to assistive technology. However, a rating of Partially Supports has been given for the following reasons:<br />
									Frame titles are not meaningful, from 3rd-party iframes like:<br />
									• Calendly on all pages<br />
									• GoogleMaps in Event Landing page<br />
									• Stripe in Checkout process</td>
								</tr>
							</tbody>
						</table>
						<br /><br />
						<h2>Table 2: Success Criteria, Level AA</h2>
						<table className="showtix-table showtix-table__accessibility">
							<thead>
								<tr>
									<th>Criteria</th>
									<th>Conformance Level</th>
									<th>Remarks and Explanations</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
									1.2.4 Captions (Live) (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U uses Vimeo to display any video or audio performances.<br />
									The Promoters providing the performance must provide captions and/or description, Showtix4U is not responsible for the content.<br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054813011-Arts-Organization-Closed-Captioning-ASL-For-Live-Stream">Closed Captioning for Live Stream</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363092-Arts-Organization-Closed-Captioning-for-Scheduled-Content-SC-">Closed Captioning for Scheduled Content</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363412-Arts-Organization-Closed-Captioning-for-Video-On-Demand-VOD-">Closed Captioning for Video On Demand</a>
									</td>
								</tr>
								<tr>
									<td>
									1.2.5 Audio Description (Prerecorded) (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U uses Vimeo to display any video or audio performances.<br />
									The Promoters providing the performance must provide captions and/or description, Showtix4U is not responsible for the content.<br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054813011-Arts-Organization-Closed-Captioning-ASL-For-Live-Stream">Closed Captioning for Live Stream</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363092-Arts-Organization-Closed-Captioning-for-Scheduled-Content-SC-">Closed Captioning for Scheduled Content</a><br />
									• <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360054363412-Arts-Organization-Closed-Captioning-for-Video-On-Demand-VOD-">Closed Captioning for Video On Demand</a>
									
									</td>
								</tr>
								<tr>
									<td>
									1.3.4 Orientation (Level AA 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not restrict its view and operation to a single display orientation.
									</td>
								</tr>
								<tr>
									<td>
									1.3.5 Identify Input Purpose (Level AA 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U’s input fields collecting information can be programmatically determined.
									</td>
								</tr>
								<tr>
									<td>
									1.4.3 Contrast (Minimum) (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U meets the minimum contrast ratio.
									</td>
								</tr>
								<tr>
									<td>
									1.4.4 Resize text (Level AA)
									</td>
									<td>
									Partially supports
									</td>
									<td>
Showtix4U text can mostly be resized without loss of content or functionality. A rating of Partially Supports has been given for the following reasons:
<br />There might some overlapping or cutting of text when zoomed at 200%.
									</td>
								</tr>
								<tr>
									<td>
									1.4.5 Images of Text (Level AA)
									</td>
									<td>
									N/A
									</td>
									<td>
									Showtix4U does not make use of images of text.
									</td>
								</tr>
								<tr>
									<td>
									1.4.10 Reflow (Level AA 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U presents content without loss of information or functionality with one dimensional scrolling, and without requiring scrolling in two dimensions.
									</td>
								</tr>
								<tr>
									<td>
									1.4.11 Non-text Contrast (Level AA 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U presents user interface components and graphical objects that meet the minimum contrast ratio.
									</td>
								</tr>
								<tr>
									<td>
									1.4.12 Text Spacing (Level AA 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not present text where content or functionality are lost when setting custom spacing.
									</td>
								</tr>
								<tr>
									<td>
									1.4.13 Content on Hover or Focus (Level AA 2.1 only)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U does not contain controls that become visible on pointer hover or keyboard focus.
									</td>
								</tr>
								<tr>
									<td>
									2.4.5 Multiple Ways (Level AA)
									</td>
									<td>
									N/A
									</td>
									<td>
									Showtix4U doesn’t have multiple pages and offers a one step process for checkout.
									</td>
								</tr>
								<tr>
									<td>
									2.4.6 Headings and Labels (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									
Showtix4U provides headings and labels that describe the topic or purpose.


									</td>
								</tr>
								<tr>
									<td>
									2.4.7 Focus Visible (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U provides a visible indication of keyboard focus for all actionable elements on its pages.
									</td>
								</tr>
								<tr>
									<td>
									3.1.2 Language of Parts (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									Content on Showtix4U is only presented in one language at this time.
									</td>
								</tr>
								<tr>
									<td>
									3.2.3 Consistent Navigation (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U uses a consistent navigational mechanism across screens.
									</td>
								</tr>
								<tr>
									<td>
									3.2.4 Consistent Identification (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U consistently identifies components that have the same functionality.
									</td>
								</tr>
								<tr>
									<td>
									3.3.3 Error Suggestion (Level AA)
									</td>
									<td>
									Doesn’t Support

									</td>
									<td>
									Showtix4U’s error messages don't provide suggestions to users.
									</td>
								</tr>
								<tr>
									<td>
									3.3.4 Error Prevention (Legal, Financial, Data) (Level AA)
									</td>
									<td>
									Supports
									</td>
									<td>
									Showtix4U uses Stripe as a 3rd party to handle the financial transaction.
									</td>
								</tr>
								<tr>
									<td>
									4.1.3 Status Messages (Level AA 2.1 only)
									</td>
									<td>
									N/A
									</td>
									<td>
									There's no status messages on Showtix4U.
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		);
  	}
}

export default Accessibility;



// WEBPACK FOOTER //
// ./src/components/Accessibility/Accessibility.js